import gridFilter from "../util/gridFilter";

export default {
  init() {
    // JavaScript to be fired on the about us page
    let globalCount = 10;
    gridFilter(globalCount);

    $(window).on("scroll", function () {
      if (!$("body").hasClass("no-load")) {
        if (
          window.innerHeight + window.scrollY >=
          $(".load-more").offset().top
        ) {
          globalCount += 10;
          loadMore();
        }
      }
    });

    function loadMore() {
      $("body").addClass("no-load");
      let reviewBase = $(".reviews--grid--view");
      for (let i = 0; i < globalCount; i++) {
        let next = reviewBase
          .find(".reviews--grid--item:not(.hidden):not(.in-view)")
          .first();
        if (!next.length > 0) {
          console.log("Break loop"); //eslint-disable-line
          $(".load-more p").html("No more reviews to show");
          break;
        } else {
          next.addClass("in-view");
        }
      }

      setTimeout(() => {
        $("body").removeClass("no-load");
      }, 1000);
    }

    function preset() {
      $(".preselect").trigger("click");
    }

    preset();

    $(".grid--filter--toggle").on("click", () => {
      $(".grid--filter").toggleClass("open");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/reviews.js